import { MaskedFieldInputEvent } from '@cof/fs-masked-field-manager-base';
export const phoneNumberFieldEventType = {
    'phone-number-field-input': 'phone-number-field-input'
};
export class PhoneNumberFieldInputEvent extends MaskedFieldInputEvent {
    /* c8 ignore next 14 - NOTE: C8 not properly covering constructor */
    constructor(validityState, maskedValue, unmaskedValue, originalTarget) {
        super(phoneNumberFieldEventType['phone-number-field-input'], validityState, maskedValue, unmaskedValue, originalTarget);
    }
}
//# sourceMappingURL=PhoneNumberFieldEvent.js.map